import { render, staticRenderFns } from "./Document_reduce_details.vue?vue&type=template&id=51ba4a2c&scoped=true&"
import script from "./Document_reduce_details.vue?vue&type=script&lang=js&"
export * from "./Document_reduce_details.vue?vue&type=script&lang=js&"
import style0 from "./Document_reduce_details.vue?vue&type=style&index=0&id=51ba4a2c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ba4a2c",
  null
  
)

export default component.exports